module.exports = __webpack_public_path__ + "static/media/20ECE21.7250e13a.jpg";